/* ============================================================
   CLASE 33 — Animations
   Intersection Observer + Mobile floating bottle
   ============================================================ */

(function () {
  'use strict';

  /* ── Intersection Observer (scroll-triggered reveals) ──────── */
  function initScrollReveal() {
    const targets = document.querySelectorAll(
      '.c33-era, .c33-proceso-card, .c33-botella-card'
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Mobile floating bottle ──────────────────────────────────── */
  function initMobileIntro() {
    const intro = document.querySelector('.c33-mobile-intro');
    if (!intro) return;

    /* Only on mobile */
    if (window.innerWidth > 768) {
      intro.remove();
      return;
    }

    intro.classList.add('is-active');

    function dismiss() {
      intro.classList.add('dismissed');
      /* Allow body scroll again after transition */
      setTimeout(function () {
        intro.style.display = 'none';
      }, 650);
    }

    /* Auto-dismiss after 2.5s */
    var autoTimer = setTimeout(dismiss, 2500);

    /* Dismiss on first scroll */
    window.addEventListener(
      'scroll',
      function () {
        clearTimeout(autoTimer);
        dismiss();
      },
      { once: true, passive: true }
    );

    /* Also dismiss on tap */
    intro.addEventListener(
      'click',
      function () {
        clearTimeout(autoTimer);
        dismiss();
      },
      { once: true }
    );
  }

  /* ── Comic Timeline — paneles secuenciales ──────────────────── */
  function initBottleTimeline() {
    var timeline = document.getElementById('comic-timeline');
    if (!timeline) return;

    var paneles = timeline.querySelectorAll('.ct-panel');
    var animado = false;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animado) {
          animado = true;
          paneles.forEach(function(panel) {
            panel.classList.add('visible');
          });
        }
      });
    }, { threshold: 0.2 });

    observer.observe(timeline);
  }

  /* ── Boot ────────────────────────────────────────────────────── */
  function boot() {
    initScrollReveal();
    initMobileIntro();
    initBottleTimeline();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
